import { render, staticRenderFns } from "./AutoDates.vue?vue&type=template&id=0be2105a&scoped=true"
import script from "./AutoDates.vue?vue&type=script&lang=js"
export * from "./AutoDates.vue?vue&type=script&lang=js"
import style0 from "./AutoDates.vue?vue&type=style&index=0&id=0be2105a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be2105a",
  null
  
)

export default component.exports